import { httpGet, httpPut } from "@/request/http";

let path = "/KDSServers";

export default {
  getGroups() {
    return httpGet(`${path}/group`);
  },
  getServers() {
    return httpGet(`${path}/names`);
  },
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  put(item) {
    return httpPut(path, item);
  },
  getKDSs(id) {
    return httpGet(`${path}/${id}/kdss`);
  },
  saveTerminals(id, ids) {
    return httpPut(`${path}/${id}/terminals`, ids);
  },
  removeTerminals(id, ids) {
    return httpPut(`${path}/${id}/terminals/unassign`, ids);
  },
};
